<template>
  <div class="history">
    <!-- card -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>车辆统计</span>
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="jump('/carstatics/setInfo')"
          >车辆设置</el-button
        >
      </div>

      <!-- 筛选 -->
      <el-row>
        <!-- 时间选择 -->
        <el-col :span="7">
          <el-date-picker
            v-model="pickerDate"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :editable="false"
            unlink-panels
            :picker-options="pickerOptions"
            @change="handleDateChange"
          >
          </el-date-picker>
        </el-col>

        <!-- 搜索 -->
        <!-- <el-col :span="1">
          <el-button
            icon="el-icon-search"
            type="primary"
            plain
            @click="search"
          ></el-button>
        </el-col> -->
        <!-- <el-col :span="6"> -->
        <!-- <el-input
            placeholder="请输入登录用户名"
            v-model="params.uname"
            class="input-with-select"
          >
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input> -->
        <!-- </el-col> -->

        <!-- <el-col :span="12">&nbsp;</el-col> -->
        <!-- 下载 -->
        <!-- <el-col :span="1">
          <el-button
            v-if="tableData.length != 0"
            icon="el-icon-download"
            type="info"
            plain
            :loading="downloadLoading"
            @click="download"
          ></el-button>
        </el-col> -->
      </el-row>
      <!-- 筛选 -->

      <!-- 表格 -->
      <TzTable :tableData="tableData" :columns="columns" />
      <!-- <el-table :data="tableData" border style="width: 100%" ref="table">
        <el-table-column
          v-for="(item, i) in column"
          :key="i"
          :prop="item.prop"
          :label="item.label"
          sortable
        >
        </el-table-column>
        <el-table-column
          v-for="(item, i) in columns"
          :key="i + 'i'"
          :prop="item.prop"
          :label="item.label"
          sortable
        >
        </el-table-column>
      </el-table> -->
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <!-- card -->
  </div>
</template>

<script>
// import tableData from '~mock/users/history'
// import fileDownload from 'js-file-download'
import TzTable from '@/components/tz-table/Index.vue'
import { carCount } from '@/api/workinghours'
export default {
  components: {
    TzTable
  },

  data() {
    return {
      downloadLoading: false,
      page: 1, //当前页
      limit: 10, //
      total: 100,
      pickerDate: [], //日期 默认一个月
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        disabledDate: (time) => {
          return time.getTime() > Date.now()
        }
      },

      // 表格动态列
      columns: [
        // {
        //   title: '车牌号',
        //   type: 'detail',
        //   payload: {
        //     field: 'personName',
        //     click: (row) => {
        //       console.log('查看详情', row)
        //       this.$router.push({
        //         path: '/workinghours/info',
        //         query: {
        //           personId: row.personId,
        //           startDt: this.pickerDate[0] || '',
        //           endDt: this.pickerDate[1] || ''
        //         }
        //       })
        //     }
        //   }
        // },
        {
          field: 'carNum',
          title: '车牌号',
          width: ''
        },
        {
          field: 'userName',
          title: '驾驶员'
        },
        {
          field: 'travelNum',
          title: '总里程（公里）'
        },
        {
          field: 'stopNum',
          title: '违停次数'
        },
        {
          title: '',
          width: '200',
          type: 'btn',
          payload: [
            {
              name: '详情',
              type: 'primary',
              click: (row) => {
                console.log('查看详情', row)
                this.$router.push({
                  path: '/carstatics/info',
                  query: {
                    carNum: row.carNum,
                    startTime: this.pickerDate[0] || '',
                    endTime: this.pickerDate[1] || ''
                  }
                })
              }
            },
            {
              name: '异常停车',
              type: 'danger',
              click: (row) => {
                console.log('异常', row)
                this.$router.push({
                  path: '/carstatics/abnormal',
                  query: {
                    carNum: row.carNum,
                    startTime: this.pickerDate[0] || '',
                    endTime: this.pickerDate[1] || ''
                  }
                })
              }
            }
          ]
        }
      ],
      // 表格数据
      tableData: []
    }
  },
  methods: {
    // 默认时间
    defaultTime() {
      if (this.pickerDate.length == 0) {
        // 默认当前日期之前365天
        let sdate = new Date()
        let interval = -30 //间隔天数
        let caret = '-' //日期分隔符
        let strYear = sdate.getFullYear()
        let strDay = sdate.getDate()
        let strMonth = sdate.getMonth() + 1
        let patt1 = /^\d{4}-([0-1]?[0-9])-([0-3]?[0-9])$/ //判断输入的日期是否符合格式正则表达式
        if (!(sdate && typeof sdate == 'string' && patt1.test(sdate))) {
          sdate = new Date() //不满足日期的则使用当前年月日
        }
        interval = isNaN(parseInt(interval)) ? 0 : parseInt(interval) //若没有输入间隔，则使用当前日
        caret = caret && typeof caret == 'string' ? caret : ''
        let gdate = new Date(sdate).getTime() //获取指定年月日
        gdate = gdate + 1000 * 60 * 60 * 24 * interval //加减相差毫秒数
        let speDate = new Date(gdate) //获取指定好毫秒数时间
        let preYear = speDate.getFullYear()
        let preMonth = speDate.getMonth() + 1
        let preDay = speDate.getDate()
        preMonth = preMonth < 10 ? '0' + preMonth : preMonth
        preDay = preDay < 10 ? '0' + preDay : preDay
        let preDate = preYear + caret + preMonth + caret + preDay
        this.pickerDate = [preDate, strYear + '-' + strMonth + '-' + strDay]
      }
    },
    handleSizeChange(val) {
      this.limit = val
      this.pageListFn()
    },
    handleCurrentChange(val) {
      this.page = val
      this.pageListFn()
    },
    //选择日期事件
    handleDateChange(dialogPickerDate) {
      console.log(dialogPickerDate)
      if (dialogPickerDate == null) {
        this.pickerDate = []
      }
      this.page = 1
      this.pageListFn()
    },

    //获取数据
    pageListFn() {
      var data = {
        startTime: this.pickerDate[0] || '',
        endTime: this.pickerDate[1] || '',
        pageNum: this.page,
        pageSize: this.limit
      }
      carCount(data).then((res) => {
        console.log(res, '车辆统计')
        if (res.code == 200) {
          this.total = res.data.total
          this.tableData = res.data.records
        }
      })
    },
    // 点击搜索
    search() {
      this.pageListFn()
    }
    //下载
    // download() {
    //   this.downloadLoading = true
    //   var data = {
    //     startDt: this.pickerDate[0] || '',
    //     endDt: this.pickerDate[1] || '',
    //     type: this.type
    //   }
    //   workloadExport(data).then((res) => {
    //     fileDownload(res, '工作量统计.xlsx')
    //   })
    //   this.downloadLoading = false
    // }
  },
  created() {
    this.defaultTime()
  },
  mounted() {
    this.pageListFn()
  }
}
</script>

<style lang="scss" scoped>
.clearfix {
  display: flex;
  justify-content: space-between;
}
</style>
